module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-svgrepo-com.52778b42.svg";